import React, { useRef, useEffect } from 'react'
import { Fade } from 'react-awesome-reveal'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const ExpSection = ({ onSectionChange, currentSection }) => {
  const expSectionRef = useRef()

  const { t } = useTranslation()

  const handleScroll = (event) => {
    const scrollTop = expSectionRef.current.getBoundingClientRect().bottom
    if (scrollTop <= 100 && currentSection === 'section4') {
      onSectionChange('section5')
    } else if (scrollTop > 100 && currentSection === 'section5') {
      onSectionChange('section4')
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  const academics = [
    {
      dates: '2021',
      title: 'Certified Kubernetes Application Developer (CKAD)',
      description: t('experienceSection.academics.kodekloud')
    },
    {
      dates: '2018',
      title: 'Cloud Computing',
      description: t('experienceSection.academics.learningtree')
    },
    {
      dates: '2017',
      title: 'UX & UI Design certificate',
      description: t('experienceSection.academics.learningtree')
    },
    {
      dates: '2014 - 2019',
      title: 'Master of Science',
      description: 'SUPINFO International University'
    }
  ]

  const jobs = [
    {
      dates: '2020 - ' + t('experienceSection.present'),
      title: 'Freelance software engineer',
      description: t('experienceSection.jobs')[0].description
    },
    {
      dates: '2017 - ' + t('experienceSection.present'),
      title: 'Lead software engineer',
      description: t('experienceSection.jobs')[1].description
    },
    {
      dates: '2014 - ' + t('experienceSection.present'),
      title: 'University teacher',
      description: t('experienceSection.jobs')[2].description
    },
    {
      dates: '2015 - 2017',
      title: 'Software engineer',
      description: t('experienceSection.jobs')[3].description
    }
  ]

  return (
    <section
      ref={expSectionRef}
      id="section4"
      className="pt-10 relative bg-gray-100 w-full"
    >
      <div className="w-5/6 md:w-3/4 lg:w-4/6 mx-auto py-16">
      <Fade direction="up">
        <h2 className="title font-bold text-4xl text-martinique relative z-10">
            Experience
        </h2>
      </Fade>


      <div className="flex flex-col space-x-0 space-y-6 md:space-y-0 md:space-x-6 md:flex-row pt-12 md:pt-24 justify-between items-start content-center">
            <Fade key="index" delay="0">
              <article className="shadow-lg rounded-2xl bg-white duration-300 transform transition hover:-translate-y-3 text-left">
                <img alt="Claper" width="800" height="600" className="rounded-t-2xl" src={'/img/claper.png'} />
                <a href="https://get.claper.co/" target="_target" className="hover:text-radical-red text-martinique duration-200 transition">
                  <h3 className="py-3 px-4 text-xl font-bold">Claper</h3>
                </a>
                <div className="pb-4 px-4 text-sm text-gray-500">Side project - Claper is the modern way to communicate with your public through real-time features (Elixir - Phoenix)</div>
              </article>
              </Fade>
              <Fade key="index" delay="0">
              <article className="shadow-lg rounded-2xl bg-white duration-300 transform transition hover:-translate-y-3 text-left">
                <img alt="Participate" width="800" height="600" className="rounded-t-2xl" src={'/img/participate.png'} />
                <a href="https://participate.events" target="_target" className="hover:text-radical-red text-martinique duration-200 transition">
                  <h3 className="py-3 px-4 text-xl font-bold">Participate</h3>
                </a>
                <div className="pb-4 px-4 text-sm text-gray-500">Client project - Participate is a mobile app centered on events and crypto/NFT (Flutter - VueJS - Web3)</div>
              </article>
              </Fade>
              <Fade key="index" delay="0">
              <article className="shadow-lg rounded-2xl bg-white duration-300 transform transition hover:-translate-y-3 text-left">
                <img alt="Projects" width="800" height="600" className="rounded-t-2xl" src={'/img/projects.png'} />
                <a href="https://alexlion.notion.site/b1da64e72c404b7895b578484934ebfe?v=e95ac61251984ec394d76007f2551bf1" target="_target" className="hover:text-radical-red text-martinique duration-200 transition">
                  <h3 className="py-3 px-4 text-xl font-bold">More projects</h3>
                </a>
                <div className="pb-4 px-4 text-sm text-gray-500">Discover more projects...</div>
              </article>
              </Fade>
        </div>

        <div className="flex flex-col md:flex-row pt-12 md:pt-24 justify-start items-start content-center">
            <div id="academics" className="bg-white relative w-full md:w-1/2 p-6 rounded-3xl shadow-lg md:mr-10">
              {academics.map((value, index) => {
                return <div className={`relative ml-24 ${index > 0 ? 'mt-10' : ''} block-xp`} key={index}>
                  <Fade direction="up">
                  <span className="text-xs text-athens-gray-700">{ value.dates }</span>
                  <h2 className="text-xl font-bold text-martinique-400">{ value.title }</h2>
                  <p className="text-martinique-400 font-thin mt-2">{ value.description }</p>
                  </Fade>
                </div>
              })}
              <span className="line"></span>
            </div>
            <div id="jobs" className="bg-white md:w-1/2 mt-10 md:mt-0 rounded-3xl shadow-lg p-6 relative w-full">
              {jobs.map((value, index) => {
                return <div className={`relative ml-24 ${index > 0 ? 'mt-10' : ''} block-xp`} key={index}>
                    <Fade direction="up">
                    <span className="text-xs text-athens-gray-700">{ value.dates }</span>
                    <h2 className="text-xl font-bold text-martinique-400">{ value.title }</h2>
                    <p className="text-martinique-400 font-thin mt-2">{ value.description }</p>
                    </Fade>
                  </div>
              })}
                <span className="line"></span>
            </div>
        </div>
      </div>
    </section>
  )
}

export default ExpSection
